import Benzinga from "./news/bezinga.png";
import binance from "./news/binance.png";
import bitcoin from "./news/bitcoin.png";
import bnn from "./news/bnn.png";
import coinmarketcap from "./news/CoinMarketCap.png";
import cointelegraph from "./news/cointelegraph.png";
import cryptopotato from "./news/cryptopotato.png";
import decrypt from "./news/decrypt.png";
import defiant from "./news/defiant.png";

export const sources = [
  {
    name: "bezinga",
    link: "https://www.benzinga.com/pressreleases/24/02/37197333/rhuna-launches-to-revolutionize-the-events-and-entertainment-industry-with-fintech-innovation",
    logo: Benzinga,
  },
  {
    name: "binance",
    link: "https://www.binance.com/en/feed/post/4317483365330",
    logo: binance,
  },
  {
    name: "bitcoin",
    link: "https://news.bitcoin.com/rhuna-launches-to-revolutionize-the-events-and-entertainment-industry-with-fintech-innovation/",
    logo: bitcoin,
  },
  {
    name: "bnn",
    link: "https://bnnbreaking.com/tech/rhuna-revolutionizes-untold-festival-with-blockchain-bringing-a-new-era-to-event-ticketing-in-cluj-napoca",
    logo: bnn,
  },
  {
    name: "coinmarketcap",
    link: "https://coinmarketcap.com/community/articles/65d2f41ab45e755c4619e329",

    logo: coinmarketcap,
  },
  {
    name: "cointelegraph",
    link: "https://cointelegraph.com/press-releases/rhuna-launches-to-revolutionize-the-events-and-entertainment-industry-with-fintech-innovation           ",
    logo: cointelegraph,
  },
  {
    name: "cryptopotato",
    link: "https://cryptopotato.com/rhuna-launches-to-revolutionize-the-events-and-entertainment-industry-with-fintech-innovation/",
    logo: cryptopotato,
  },
  {
    name: "decrypt",
    link: "https://decrypt.co/218021/rhuna-launches-to-revolutionize-the-events-and-entertainment-industry-with-fintech-innovation           ",
    logo: decrypt,
  },
  {
    name: "defiant",
    link: "https://thedefiant.io/rhuna-launches-to-revolutionize-the-events-and-entertainment-industry-with-fintech-innovation",
    logo: defiant,
  },
];
